import { render } from "./PasteInput.vue?vue&type=template&id=785b298c"
import script from "./PasteInput.vue?vue&type=script&lang=js"
export * from "./PasteInput.vue?vue&type=script&lang=js"

import "./PasteInput.vue?vue&type=style&index=0&id=785b298c&lang=scss"

import exportComponent from "/app/tmp/origina/V3/v2026.7.r0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__